import { default as GlobalStore } from './GlobalStore';

export * from './GlobalStore';
export default GlobalStore;
